import { useCallback } from "react"

import { Tabs, TabsList, TabsTrigger } from "@/domains/common/components/tabs"

export type GroupVotingRewardsBy = "nft" | "pool" | "token"

export interface GroupVotingRewardsByTabsProps {
  value: GroupVotingRewardsBy
  onValueChange: (value: GroupVotingRewardsBy) => void
  className?: string
}

const isValidValue = (v: string): v is GroupVotingRewardsBy => {
  return ["nft", "pool", "token"].includes(v)
}

export const VotingRewardsGroupByTabs = ({ value, onValueChange, className }: GroupVotingRewardsByTabsProps) => {
  const handleValueChange = useCallback(
    (value: string) => {
      if (!isValidValue(value)) {
        console.warn(`Invalid tab value: ${value}`)
        return "all"
      }
      onValueChange(value as GroupVotingRewardsBy)
    },
    [onValueChange],
  )

  return (
    <Tabs value={value} defaultValue="all" onValueChange={handleValueChange}>
      <TabsList className={className}>
        <TabsTrigger value="token">Token</TabsTrigger>
        <TabsTrigger value="nft">NFT</TabsTrigger>
        {/* <TabsTrigger value="pool">Pool</TabsTrigger> */}
      </TabsList>
    </Tabs>
  )
}
